import React, { useState } from "react";
import styled from "styled-components";
import { CircularProgress } from "@material-ui/core";

const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

const StyledImg = styled.img`
  display: block;
  width: 100%;
  height: auto;
  vertical-align: bottom;
  transition: opacity 0.3s ease;
  opacity: ${(props) => (props.loaded ? 1 : 0)};
`;

const LoadingPlaceholder = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: transparent;
  opacity: ${(props) => (props.show ? 1 : 0)};
  transition: opacity 0.3s ease;
  pointer-events: none;
`;

const Image = ({ src, alt = "", onLoadComplete, onError }) => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  const handleLoad = (event) => {
    setLoaded(true);
    if (onLoadComplete) {
      onLoadComplete(event);
    }
  };

  const handleError = (event) => {
    setError(true);
    setLoaded(true);
    if (onError) {
      onError(event);
    }
  };

  return (
    <ImageWrapper>
      <LoadingPlaceholder show={!loaded}>
        {error ? "Kunne ikke laste bilde" : <CircularProgress size={40} />}
      </LoadingPlaceholder>
      <StyledImg
        src={src}
        alt={alt}
        loading="lazy"
        loaded={loaded}
        onLoad={handleLoad}
        onError={handleError}
      />
    </ImageWrapper>
  );
};

export default Image;
